export default "__VITE_ASSET__Bc5u79_l__"